import { AccountType } from '@pelicargo/types';
import { getPrettyAccountType } from '@pelicargo/utils';
import { useMemo } from 'react';

import { Request } from '../../utils/types';

export const useAccountType = (type: AccountType | Request['account']['type'], iata?: string) => {
  return useMemo(() => {
    if (!type) return { label: 'Account Type', value: '-' };

    const isIata = type === AccountType.IATA;
    if (isIata) return { label: 'IATA', value: iata };

    return {
      label: 'Account Type',
      value: getPrettyAccountType(type as AccountType),
    };
  }, [type, iata]);
};
